import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { apiEndpoints } from '../../constants/api-endpoints';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getLocations() {
    return this.httpUtilityService.get<any[]>(apiEndpoints.reportLocationList);
  }

  getPurchasingList() {
    return this.httpUtilityService.get<any[]>(
      apiEndpoints.reportPurchasingList
    );
  }

  getBuyers(purchasingOffice: string = 'ALL') {
    return this.httpUtilityService.getByParam<any[]>(
      apiEndpoints.reportBuyerList,
      { purchasingOffice }
    );
  }

  getOwners(purchasingOffice: string = 'ALL') {
    return this.httpUtilityService.getByParam<any[]>(
      apiEndpoints.reportOwnerList,
      { purchasingOffice }
    );
  }

  getCCNList() {
    return this.httpUtilityService.get<any[]>(apiEndpoints.reportCCNList);
  }

  getDetailsReports(payload: any) {
    return this.httpUtilityService.post<any[]>(
      apiEndpoints.detailsReportList,
      payload
    );
  }

  exportDetailsReport(payload: any) {
    return this.httpUtilityService.post<any>(
      apiEndpoints.exportDetailsReport,
      payload,
      'blob'
    );
  }

  getCycleReports(payload: any) {
    return this.httpUtilityService.post<any[]>(
      apiEndpoints.reportCycleList,
      payload
    );
  }

  exportCycleExcelReport(params: any) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== '' &&
        (key === 'Status' || params[key] !== 'ALL')
      ) {
        httpParams = httpParams.set(key, params[key]);
      }
    });

    return this.httpUtilityService.getByOptions<any>(
      apiEndpoints.exportCycleExcelReport,
      {
        params: httpParams,
        responseType: 'blob',
      }
    );
  }

  getItemDetailsReport(params: any) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        httpParams = httpParams.set(key, params[key]);
      }
    });

    return this.httpUtilityService.getByParam<any[]>(
      apiEndpoints.itemDetailsReportList,
      params
    );
  }

  exportItemDetailsExcelReport(params: any) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        httpParams = httpParams.set(key, params[key]);
      }
    });

    return this.httpUtilityService.getByOptions<any>(
      apiEndpoints.exportItemDetailsExcelReport,
      {
        params: httpParams,
        responseType: 'blob',
      }
    );
  }
}
